export default __webpack_public_path__ + "static/media/addtocart.423c1b1b.svg";